import { createFeature, createReducer, on } from '@ngrx/store';
import { ErrorHandlerActions } from './error-handler.actions';
import { HttpErrorResponse } from '@angular/common/http';

export const errorHandlerFeatureKey = 'errorHandler';

export interface State {
  error: HttpErrorResponse | null;
}

export const initialState: State = {
  error: null,
};

export const errorHandlerReducer = createReducer(
  initialState,
  on(ErrorHandlerActions.throwError, (state, { error }) => ({
    ...state,
    error,
  })),
  on(ErrorHandlerActions.clearError, (state) => ({
    ...state,
    error: null,
  }))
);

export const errorHandlerFeature = createFeature({
  name: errorHandlerFeatureKey,
  reducer: errorHandlerReducer,
});
